import React, { useState } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import styles from './Cover.module.scss';

export interface CoverProps {
  src?: string | null;
  /** Used for the initials fallback when there is no image, or when the image fails to load. */
  label?: string;
  size?: number;
  /** Border radius in px, or a string (e.g. "50%" for avatars). */
  radius?: number | string;
  className?: string;
}

const CoverComponent: React.FC<CoverProps> = ({ src, label, size = 40, radius = 8, className }) => {
  const borderRadius = typeof radius === 'number' ? `${radius}px` : radius;
  const initials = label ? label.slice(0, 1).toUpperCase() : '';
  // The URL that failed to load (an expired CDN URL answers 403). A new URL tries again.
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  if (src !== undefined && src !== null && src !== '' && src !== failedSrc) {
    return (
      <img
        src={src}
        alt={label ?? ''}
        className={clsx(styles.cover, className)}
        style={{ width: size, height: size, borderRadius }}
        loading="lazy"
        onError={() => setFailedSrc(src)}
      />
    );
  }

  return (
    <div
      className={clsx(styles.cover, styles.fallback, className)}
      style={{ width: size, height: size, borderRadius, fontSize: size * 0.34 }}
      aria-hidden
    >
      {initials}
    </div>
  );
};

export const Cover = TypedMemo(CoverComponent);
